import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
    Container,
    Typography,
    Tabs,
    Tab,
    Paper,
} from '@material-ui/core';
import RateReviewIcon from '@material-ui/icons/RateReview';
import DescriptionIcon from '@material-ui/icons/Description';

import StudyApprovalsTab from './StudyApprovalsTab';
import FindingsTab from './FindingsTab';

const PageContainer = styled(Container)`
    padding-top: 3em;
    padding-bottom: 3em;
`;

const PageTitle = styled(Typography)`
    margin-bottom: 1em;
    font-weight: 700;
`;

const StyledTabs = styled(Tabs)`
    margin-top: 1.5em;
`;

const TabContent = styled.div`
    margin-top: 0.5em;
`;

export default function AdminPage() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <PageContainer maxWidth="md">
            <PageTitle variant="h4" color="primary">
                {t('admin_pageTitle')}
            </PageTitle>
            <Typography variant="body2" color="textSecondary">
                {t('admin_pageDescription')}
            </Typography>

            <Paper elevation={0}>
                <StyledTabs
                    value={activeTab}
                    onChange={(_, newValue) => setActiveTab(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab icon={<RateReviewIcon />} label={t('admin_approvalsTabTitle')} />
                    <Tab icon={<DescriptionIcon />} label={t('admin_findingsTabTitle')} />
                </StyledTabs>
            </Paper>

            <TabContent>
                {activeTab === 0 && <StudyApprovalsTab />}
                {activeTab === 1 && <FindingsTab />}
            </TabContent>
        </PageContainer>
    );
}
